import { useNavigate } from 'react-router-dom'

import Pagination from '@10xLabs/react-web/components/Pagination'
import { PaginationCaption } from 'features/App/components/PaginationCaption'
import { getDateRangeQuery } from 'utils/date'
import { getQueryString } from 'utils/route'

export const OrdersPagination = (props: TSFixMe): TSFixMe => {
  const navigate = useNavigate()

  const { page, totalItems, limit, currentItemsCount, filters } = props

  const creationDateRangeQuery = getDateRangeQuery(filters.creationDateRange)

  const setPage = (page: TSFixMe): TSFixMe => {
    const query = {
      page,
      id: filters.id,
      status: filters.status,
      type: filters.type,
      creationDateFrom: creationDateRangeQuery.from,
      creationDateTo: creationDateRangeQuery.to,
      creationDateRangeValue: creationDateRangeQuery.rangeValue,
      inventoryId: filters.inventory && filters.inventory.id
    }
    navigate(`/orders?${getQueryString(query)}`)
  }

  return (
    <Pagination.Container>
      <Pagination.Caption
        page={page}
        totalItems={totalItems}
        currentItemsCount={currentItemsCount}
        limit={limit}
        getCaptionMessage={(firstItemIndex: TSFixMe, lastItemIndex: TSFixMe): TSFixMe => (
          <PaginationCaption firstItemIndex={firstItemIndex} lastItemIndex={lastItemIndex} totalItems={totalItems} />
        )}
      />

      <Pagination.Previous page={page} setPage={setPage} />

      <Pagination.Next page={page} totalItems={totalItems} limit={limit} setPage={setPage} />
    </Pagination.Container>
  )
}
